import {
  SET_FETCH_MESSAGE,
  SET_LOADING_STATUS,
  UNSET_FETCH_MESSAGE,
  UNSET_LOADING_STATUS,
  SET_CLIENT_FILTER_INITIALIZED,
  RESET_CLIENT_FILTER_INITIALIZED,
} from "store/helper/types";

export const setLoadingStatus = () => ({
  type: SET_LOADING_STATUS,
});

export const unsetLoadingStatus = () => ({
  type: UNSET_LOADING_STATUS,
});

export const setFetchMessage = (messagePayload) => ({
  type: SET_FETCH_MESSAGE,
  payload: {
    messagePayload,
  },
});

export const unsetFetchMessage = () => ({
  type: UNSET_FETCH_MESSAGE,
});

export const setClientFilterInitialized = () => ({
  type: SET_CLIENT_FILTER_INITIALIZED,
});

export const resetClientFilterInitialized = () => ({
  type: RESET_CLIENT_FILTER_INITIALIZED,
});